import React from "react";
import { ActionsField } from "features/AdminPanel/modules/DraggableTableWrapper/modules/ActionsField/ActionsField";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { ActionFieldModalWrapper } from "features/AdminPanel/modules/DraggableTableWrapper/modules/ActionsField/modules/ActionFieldsModalWrapper/ActionFieldModalWrapper";

export const QuestionsActionField = ({
  record = {},
  handleDeleteQuestion,
  openEditQuestionmodal,
}) => {
  const isDesktop = useDesktopMediaQuery();

  const Wrapper = isDesktop ? "div" : ActionFieldModalWrapper;
  return (
    <Wrapper>
      <ActionsField
        record={record}
        hideDeleteIcon={record.is_default}
        onEdit={() => openEditQuestionmodal({ record })}
        onDelete={() => handleDeleteQuestion({ questionId: record.uuid })}
      />
    </Wrapper>
  );
};
